export function awardScopeTitle(scope) {
    const context = scope.preset === 'it' ? ' in IT services' : scope.preset === 'custom' ? ` in ${scope.codes.length} selected codes` : '';
    return `What they've awarded${context} · $M per year, by winner`;
}
const validCode = /^(NAICS:[0-9]{2,6}|PSC:[A-Z0-9]{1,4})$/;
export function readAwardScope(params) {
    const preset = params.get('awardScope');
    return {
        preset: preset === 'it' || preset === 'custom' ? preset : 'all',
        codes: [
            ...new Set((params.get('awardCodes') ?? '').split(',').filter((code)=>validCode.test(code)))
        ]
    };
}
export function writeAwardScope(params, scope) {
    const next = new URLSearchParams(params);
    if (scope.preset === 'all') next.delete('awardScope');
    else next.set('awardScope', scope.preset);
    if (scope.codes.length) next.set('awardCodes', scope.codes.join(','));
    else next.delete('awardCodes');
    return next;
}
export function awardScopeRequest(scope) {
    return {
        scopePreset: scope.preset === 'it' ? 'IT_SERVICES' : '',
        naicsPrefixes: scope.preset === 'custom' ? scope.codes.filter((c)=>c.startsWith('NAICS:')).map((c)=>c.slice(6)) : [],
        pscPrefixes: scope.preset === 'custom' ? scope.codes.filter((c)=>c.startsWith('PSC:')).map((c)=>c.slice(4)) : []
    };
}
